import { Link, useLocation } from "react-router-dom";
import {
  Home,
  Briefcase,
  Package,
  Layers,
  Settings,
  Users,
  Phone,
} from "lucide-react";

const links = [
  { to: "/", label: "Home", icon: Home },
  { to: "/work", label: "Work", icon: Briefcase },
  { to: "/products", label: "Products", icon: Package },
  { to: "/solutions", label: "Solutions", icon: Layers },
  { to: "/services", label: "Services", icon: Settings },
  { to: "/careers", label: "Careers", icon: Users },
];

export default function MobileMenu({ isOpen, setIsOpen }) {
  const location = useLocation();

  return (
    <div
      className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${
        isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
      }`}
    >
      <ul className="bg-[#0B1D3F] border-t border-white/10 px-4 py-5 space-y-1">
        {links.map(({ to, label, icon: Icon }, i) => {
          const isActive = location.pathname === to;
          return (
            <li
              key={to}
              className={`transition-all duration-300 ease-out ${
                isOpen
                  ? "translate-x-0 opacity-100"
                  : "-translate-x-3 opacity-0"
              }`}
              style={{ transitionDelay: isOpen ? `${i * 60}ms` : "0ms" }}
            >
              <Link
                onClick={() => setIsOpen(false)}
                to={to}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl text-[15px] font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-orange-600/15 text-orange-500"
                    : "text-gray-300 hover:bg-white/5 hover:text-white"
                }`}
              >
                <Icon
                  size={18}
                  strokeWidth={2}
                  className={isActive ? "text-orange-500" : "text-gray-400"}
                />
                {label}
              </Link>
            </li>
          );
        })}

        <li
          className={`pt-2 transition-all duration-300 ease-out ${
            isOpen ? "translate-x-0 opacity-100" : "-translate-x-3 opacity-0"
          }`}
          style={{ transitionDelay: isOpen ? `${links.length * 60}ms` : "0ms" }}
        >
          <Link
            onClick={() => setIsOpen(false)}
            to="/contact"
            className="flex items-center justify-center gap-2 bg-orange-600 hover:bg-orange-500 active:scale-[0.98] text-black font-semibold py-3 rounded-full transition-all duration-200"
          >
            <Phone size={16} strokeWidth={2.5} />
            Contact Us
          </Link>
        </li>
      </ul>
    </div>
  );
}